import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as stores from '../stores'

/** Employee model {@link ents.extra.quiver.resources.data.dimensions.personnel.entities.employee.MODEL_ID id} */
const EMPLOYEE_MODEL_ID =
  ents.extra.quiver.resources.data.dimensions.personnel.entities.employee
    .MODEL_ID

/**
 * Page in Summit used to edit your notes
 */
@ngCore.Component({
  imports: [
    ds.overlay.slideout.Component,
    ds.input.select.multiple.Component,
    ds.input.textArea.Component,
  ],
  selector: 'atn-summit-archive-configurator',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.OnInit {
  /** @see {@link LayoutStore} */
  public readonly layoutStore = ngCore.inject(stores.Layout)
  /** @see {@link stores.EcWrapper} */
  /** @see {@link state.summit.archive.Collection} */
  public readonly archiveEc = ngCore.inject(state.summit.archive.Collection)
  /** @see {@link state.display.referenceRecords.Feature} */
  private readonly _referenceRecordsFeature = ngCore.inject(
    state.display.referenceRecords.Feature,
  )

  /** Employee records formatted as {@link ds.input.select.models.Item} */
  public readonly employeeItems = this._referenceRecordsFeature.selectors
    .getRecords({
      entityId: EMPLOYEE_MODEL_ID,
    })
    .project(items =>
      items.map<ds.input.select.models.Item<ents.core.dms.data.Record.Id>>(
        item => ({
          label: item.name,
          value: item.id,
        }),
      ),
    )
  /** Loading state for {@link employeeItems} */
  public readonly employeeItemsLoading =
    this._referenceRecordsFeature.selectors.isLoading({
      entityId: EMPLOYEE_MODEL_ID,
    })
  /** Error state for {@link employeeItems} */
  public readonly employeeItemsError =
    this._referenceRecordsFeature.selectors.getError({
      entityId: EMPLOYEE_MODEL_ID,
    })

  /** @inheritdoc */
  ngOnInit(): void {
    this._referenceRecordsFeature.actions.loadRecords
      .from('Summit.Archive.Configurator.Init')
      .dispatch({
        cacheFirst: true,
        entityId: EMPLOYEE_MODEL_ID,
      })
  }
  /**
   * Handles reloading {@link employeeItems} from remote storage. Typically used
   * when initial loading fails.
   */
  public refetchEmployeeItemsHandler(): void {
    this._referenceRecordsFeature.actions.loadRecords
      .from('Summit.Archive.Configurator.Employees.Refetch.Clicked')
      .dispatch({
        entityId: EMPLOYEE_MODEL_ID,
      })
  }

  /**
   * dummy handler, to sync typescript types
   */
  // TODO: This can be removed once
  // `ds.input.select.multiple.Component.valueChange` is typed correctly
  public selectedEmployeeIdsChangeHandler(recordIds: readonly unknown[]): void {
    if (recordIds.every(ents.core.dms.data.Record.Id.isId.raw)) {
      this.archiveEc.currentValueChangeHandler(
        'Summit.Archive.Configurator',
        'employees',
        recordIds,
      )
    }
  }
}
